<template>
  <v-container>
    <v-row>
      <v-spacer></v-spacer>
      <v-tooltip :disabled="details.Status === 'running'" left>
        <template v-slot:activator="{ on }">
          <div v-on="on">
            <v-btn
              :disabled="details.Status.toUpperCase() !== 'RUNNING' ||
              details.TemplateStatus.toUpperCase() === 'PENDING' ||
              details.SnapshotStatus.toUpperCase() === 'PENDING'"
              class="mr-3 pr-3 pl-3 add-btn"
              color="#6db42c"
              @click="show = true"
            >Add key</v-btn>
          </div>
        </template>
        <span>You cannot add ssh key if environment has pending templates, snapshots or is stopped</span>
      </v-tooltip>
    </v-row>
    <v-card class="mt-3">
      <v-data-table
        :headers="filteredHeaders"
        :items="sshKeys"
        class="elevation-1"
        no-data-text="There are no SSH keys."
        hide-default-footer
      >
        <template v-slot:item.action="{ item }">
          <v-icon small class="mr-3" @click="onDelete(item)">far fa-trash-alt</v-icon>
        </template>
      </v-data-table>
    </v-card>
    <AssociateKeyDialog
      :show.sync="show"
      @confirmDialog="confirmDialog"
      @cancelDialog="cancelDialog"
      :userSSHKeys="userSSHKeys"
    ></AssociateKeyDialog>
    <DisassociateKeyDialog
      :showDisassociateDialog.sync="showDisassociateDialog"
      :selectedKeyToDelete="selectedKeyToDelete"
      @confirmDisassociateDialog="confirmDisassociateDialog"
      @cancelDisassociateDialog="cancelDisassociateDialog"
    ></DisassociateKeyDialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-container>
</template>

<script>
import AssociateKeyDialog from "../AssociateKeyDialog";
import DisassociateKeyDialog from "../DisassociateKeyDialog";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: "Key owner",
          align: "start",
          sortable: false,
          value: "EmailAddress",
        },
        {
          text: "Key name",
          align: "start",
          sortable: false,
          value: "Title",
        },
        {
          text: "Created",
          align: "end",
          sortable: false,
          value: "CreatedAt",
        },
        {
          text: "Action",
          align: "end",
          sortable: false,
          value: "action",
        },
      ],
      show: false,
      selectedKeyToDelete: "",
      showDisassociateDialog: false,
      loading: false,
    };
  },
  components: { AssociateKeyDialog, DisassociateKeyDialog },
  props: ["sshKeys", "userSSHKeys", "details"],
  computed: {
    filteredHeaders() {
      const state = this.details.Status;
      return state !== "running"
        ? this.headers.filter((header) => header.text !== "Action")
        : this.headers;
    },
  },
  methods: {
    ...mapActions([
      "associateKeyWithEnvironment",
      "disassociateKeyFromEnvironment",
    ]),
    cancelDialog() {
      this.show = false;
    },
    async confirmDialog(key) {
      this.show = false;
      this.loading = true;

      const params = {
        keyId: key.Id,
        environmentId: this.details.Id,
      };
      await this.associateKeyWithEnvironment(params);

      this.loading = false;
    },
    onDelete(key) {
      this.selectedKeyToDelete = key;
      this.showDisassociateDialog = true;
    },
    async confirmDisassociateDialog(key) {
      this.showDisassociateDialog = false;
      this.loading = true;

      const params = {
        keyId: key.Id,
        environmentId: this.details.Id,
      };
      await this.disassociateKeyFromEnvironment(params);

      this.loading = false;
    },
    cancelDisassociateDialog() {
      this.showDisassociateDialog = false;
    },
  },
};
</script>

<style scoped>
.add-btn {
  color: white;
}
</style>
